"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCTS = void 0;

var _general = require("./general");

var _newProduct = require("./newProduct");

var _singleProduct = require("./singleProduct");

var _stocktake = require("./stocktake");

var PRODUCTS = {
  GENERAL: _general.GENERAL,
  NEW_PRODUCT: _newProduct.NEW_PRODUCT,
  SINGLE_PRODUCT: _singleProduct.SINGLE_PRODUCT,
  STOCKTAKE: _stocktake.STOCKTAKE
};
exports.PRODUCTS = PRODUCTS;